import { useEffect } from 'react';
import useBlogStore from '../store/cmsStore/blogStore';
import Seo from '../components/Seo';
import { useNavigate } from 'react-router-dom';

const Blog = () => {
  const { blogs, fetchBlogs,sections, fetchBlogContent } = useBlogStore();
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    fetchBlogs();
    fetchBlogContent();
  }, [fetchBlogs, fetchBlogContent]);

  const handleReadMore = (id:any) => {
    navigate(`/blog-details/${id}`);
  };
  //return (<><h1>Comming Soon</h1></>);
  return (
<>
        <Seo
          title="Real Talk on Dating & Love | SLAMMMM Blog"
          description="Honest dating advice, singles' stories, and tips to help you skip the games and find something real. The SLAMMMM blog has the tips every single person needs to hear."
        />
  {sections.blog_section && (
    <section className="py-60 breadcrumb_section bg-light">
    <div className="container">
        <div className="border-bottom pb-lg-5 pb-4">
            <div className="row align-items-center">
                <div className="col-lg-5">
                    <div className="section_title">
                        <h1 className="text-primary">Blogs</h1>
                        <h2 className="mb-0">{sections.blog_section.payload.field_1.value}</h2>
                    </div>
                </div>
                <div className="col-lg-7 ps-lg-5">
                    <p className="font20 mb-0">{sections.blog_section.payload.field_2.value}
                    </p>
                </div>
            </div>
        </div>
    </div>
    </section>
     )}
     <section className="pb-60 blog_lists_section bg-light">
        <div className="container">
            <div className="row g-4">
            {blogs.slice(0, 2).map((blog) => (
                <div key={blog.id}  className="col-lg-6 col-md-6">
                    <a href="#" onClick={() => handleReadMore(blog.slug)} className="text-decoration-none">
                        <div className="blog_lists_item h-100">
                            <div className="blog_lists_item_img">
                                <img src={blog.image || 'https://via.placeholder.com/300'} alt="" className="img-fluid" />
                            </div>
                            <div className="blog_lists_item_cnt">
                                <h3 className="font28 mb-lg-4 text-dark">
                                  {blog.title}
                                </h3>
                                <span className="text-primary">Learn More <i className="fa-solid fa-arrow-right"></i></span>
                            </div>
                        </div>
                    </a>
                </div>
             ))}

            {blogs.slice(2, 20).map((blog) => (
                <div key={blog.id}  className="col-lg-4 col-md-6">
                    <a onClick={() => handleReadMore(blog.slug)} href="#" className="text-decoration-none">
                        <div className="blog_lists_item h-100">
                            <div className=" blog_lists_item_img2">
                                <img src={blog.image || 'https://via.placeholder.com/300'} alt="" className="img-fluid" />
                            </div>
                            <div className="blog_lists_item_cnt">
                                <h3 className="font28 mb-lg-4 text-dark">
                                  {blog.title}
                                </h3>
                                <span className="text-primary">Learn More <i className="fa-solid fa-arrow-right"></i></span>
                            </div>
                        </div>
                    </a>
                </div>
                 ))}
                
                
            </div>
        </div>
    </section>
 
    </>
  );
};

export default Blog;
